export default "__VITE_ASSET__DAq4qtBR__"